import { TheasoftProduct } from "../../../@client/Theasoft_DataClasses_Security"
import { useGetMyLicenses } from "../-components/use-get-my-licenses"

export function UserLicenseRestrictedView({
  children,
  licenses,
}: { licenses: TheasoftProduct[] } & React.PropsWithChildren) {
  const { data: userLicenses } = useGetMyLicenses()

  const hasAnyLicense = (licenses: TheasoftProduct[]) =>
    licenses?.some((v) => userLicenses?.some((l) => l.product === v))
  return hasAnyLicense(licenses) && children
}
